import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { LanguageCode, skipLangHeader } from 'shared-utils';
import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { UserService } from 'shared-data-access';

@Injectable()
export class LanguageHeaderInterceptor implements HttpInterceptor {
  private userService = inject(UserService);

  private readonly lang: LanguageCode = this.userService.getLanguage();

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const shouldSkip: boolean = request.headers.has(skipLangHeader);

    if (shouldSkip) {
      const cleanHeaders: HttpHeaders = request.headers.delete(skipLangHeader);
      const cleanReq: HttpRequest<unknown> = request.clone({ headers: cleanHeaders });

      return next.handle(cleanReq);
    }

    const reqClone: HttpRequest<unknown> = request.clone({ setHeaders: { lang: this.lang } });
    return next.handle(reqClone);
  }
}
